import request from '../utils/request'


export function index(params) {
  return request({
    url: '/classses',
    method: 'get',
      params
  })
}

export function inventory(params) {
  return request({
    url: '/classses/inventory',
    method: 'get',
    params
  })
}

  

export function show(id) {
    return request({
      url: `/classses/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/classses',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/classses/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/classses/${id}`,
      method: 'delete',
    })
  }
